export default ({ type }: FixmeType) => {
    return {
        chart: {
            type,
            zooming: {
                type: "x",
            },
            animation: false,
        },
        credits: {
            enabled: false,
        },
        exporting: {
            enabled: false,
        },
        yAxis: {
            title: {
                text: null,
            },
        },
        title: {
            style: {
                display: "none",
            },
        },
        plotOptions: {
            series: {
                animation: false,
            },
        },
    };
};
